import { Modal, ModalContent, ModalHeader, ModalRoot, Select } from '@pella/sash-framework';
import { useTranslation } from 'react-i18next';

/**
 * Language Selector Modal Component
 * Provides a modal for users to change the application language.
 * @param {object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {() => void} props.onClose - Callback function when modal is closed
 * @returns {import("react").ReactElement} Language selector modal component
 */
const LanguageSelector = ({ isOpen, onClose }) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    // @ts-ignore
    <ModalRoot open={isOpen} onOpenChange={onClose}>
      <Modal>
        <ModalHeader>Select Language</ModalHeader>
        <ModalContent>
          <Select id='language-select' labelText='Language' onChange={handleLanguageChange} value={i18n.language}>
            <option value='en'>English</option>
            <option value='es'>Spanish</option>
          </Select>
        </ModalContent>
      </Modal>
    </ModalRoot>
  );
};

export default LanguageSelector;
